R$ Total<template>

  <div class="pneu-lancamento ml-4 mr-4" >

      <div class="row">
      <div class="col-5">
        <div class="col-12">
          <div>
                <b-row> 


                      <b-container>
                                <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

          

              <b-card                          
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE ITENS"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ itemnf.length }}     
                  </h2>
                </b-card-text>
              </b-card>
            

            <b-card                  
            class="ml-2"
                style="width: 33rem;"
              
              border-variant="success"
              header="VALOR TOTAL DOS ITENS DA NOTA R$"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                                              {{ parseFloat(itemnf
    .map(v => parseFloat(v.valor_total) || 0) // Garantir que cada valor seja um número
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0) // Somar os valores
).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
}) }}

                  
                </h2>                
              </b-card-text>
      </b-card>        




      </b-card-group> 
                        <b-row class="mt-1 mb-1">
                          <!-- Coluna de Tamanho 8 -->
                          
                                  <b-col cols="6">
                                    <label  for="input-busca">Chave de acesso</label>  
                                    <b-form-group class="mb-1">
                                      <b-form-input id='lblChaveAcesso'  v-model="_chaveAcesso" v-mask="'#### #### #### #### #### #### #### #### #### #### ####'" @keyup.enter="loadCarregarNotaPorChaveAcesso()" required placeholder="Nro chave de acesso" v-b-tooltip.hover title="Digite o número de acesso da chave"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>


                                  <b-col cols="2">
                                    <label  for="input-busca">Nº NFS</label> 
                                    <b-form-group class="mb-1">
                                      <b-form-input v-model="nf.nfs" required placeholder="número da nfs" v-b-tooltip.hover title="Digite o número da nofa fiscal"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>

                                  
                                  <b-col cols="1">
                                    <label  for="input-busca">Série</label> 
                                    <b-form-group class="mb-1">
                                      <b-form-input v-model="nf.serie" required placeholder="" v-b-tooltip.hover title="Digite o número da série da nota fiscal"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>


                                  <b-col cols="3">
                                    <div>                            
                                        <label  for="datepicker-placeholder">Data Emissão</label>
                                        <b-form-datepicker id="datepicker-placeholder2" required v-model="nf.dt_emissao" placeholder="Emissão" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                                    </div>                     
                                  </b-col>
                          
                        </b-row>
                      </b-container>

                      <!-- FORNECEDOR -->
                      <!-- FORNECEDOR -->
                      <!-- FORNECEDOR -->
                      <!-- FORNECEDOR -->
                      <!-- FORNECEDOR -->

                      <b-container>
                        <b-row class="mt-10 mb-1">
                          
                                  <b-col cols="4">
                                    <label  for="input-busca">CNPJ do fornecedor</label> 
                                    <b-form-group class="mb-3">
                                      <b-form-input v-model="nf.cnpj" v-mask="'##.###.###/####-##'" @keyup.enter="loadFornecedor()" required placeholder="CNPJ" v-b-tooltip.hover title="Digite o cnpj do fornecedor"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>

                                  <b-col cols="8" class="mb-3">
                                    <label  for="input-busca">Razão Social</label> 
                                    <b-input-group-text>
                                      {{ nf.nome !=null ? nf.nome :  fornecedores['nome'] !=null ?  fornecedores['nome'] : '-' }}
                                    </b-input-group-text>
                                  </b-col>                          
                        </b-row>

                        <b-row>

                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ PRODUTO</label> 
                                    <NumericInput
                                      v-model="nf.vlrproduto"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 

                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ IPI</label> 
                                    <NumericInput
                                      v-model="nf.vlripi"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 

                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ ICMS</label> 
                                    <NumericInput
                                      v-model="nf.vlricms"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 

                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ FRETE</label> 
                                    <NumericInput
                                      v-model="nf.vlrfrete"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 

                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ DESCONTO</label> 
                                    <NumericInput
                                      v-model="nf.vlrdesconto"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 

                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ TOTAL NFS</label> 
                                    <NumericInput
                                      v-model="nf.vlrtotalnfs"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 
                        </b-row>
                                          <b-col cols="12">
         
                    <b-form-textarea                   
                      id="infoConteudo"
                      v-model="nf.observacao"
                      size="sm"
                      rows="1"            
                      placeholder="Observações"                      
                    ></b-form-textarea>
                  </b-col>


                      </b-container>


                        <!-- produto  -->
                        <b-container>
                          
<b-col cols="12">
  <hr id='divisao'> <!-- Linha horizontal -->
</b-col>


                        <b-row class="mt-3 mb-3">
                          <!-- Coluna de Tamanho 8 -->
                          <b-col cols="12" >
                                
                            <b-row no-gutters>
                              <!-- FOTO DO PRODUTO -->
                              


                              <!-- CODIGO DO PRODUTO -->
                              <b-col cols="12">
                                <b-row >
                                  <b-col cols="2">
                                    <label  for="input-busca">Produto</label> 
                                    <b-form-group class="mb-3">
                                      <b-form-input @keyup.enter="loadProdutos()" v-model="mercadoria.codigo_erp" required placeholder="Produto" v-b-tooltip.hover title="Digite o número do registro do funcionário"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>

                                  <b-col cols="1">
                                    <label  for="input-busca"></label> 
                                      <b-button class="mt-2 mb-3" variant="primary" block  @click="showModal" >Grid</b-button>
                                  </b-col>      
                                                                      <div>
                                      <ConsultaMaterial :visible.sync="isModalVisible" />
                                  </div>




                                  <!-- DESCRIÇÃO DO PRODUTO -->  
                                  <b-col cols="3" class="mb-3">
                                    <label  for="input-busca">Descrição do produto</label> 
                                    <b-input-group-text>
                                      {{ mercadoria.descricao ? mercadoria.descricao : materiais.descricao ? materiais.descricao : '-' }} 
                                    </b-input-group-text>
                                  </b-col>

                                                                    <!-- DESCRIÇÃO DO PRODUTO -->  
                                  <b-col cols="1" class="mb-3">
                                    <label  for="input-busca">Tamanho</label> 
                                    <b-input-group-text>
                                      {{ mercadoria.tamanho ? mercadoria.tamanho : materiais.tamanho ? materiais.tamanho : '-' }} 
                                    </b-input-group-text>
                                  </b-col>

                                  <b-col cols="1">
                                    <label  for="input-busca">QTD</label> 
                                    <b-form-group class="mb-3">
                                      <b-form-input v-model="mercadoria.quantidade" required placeholder="" v-b-tooltip.hover title="Digite a quantido do produto"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>


                                  <b-col cols="2" class="mb-2 mt-0">
                                    <label for="input-registro">R$ Valor Unitário</label> 
                                    <NumericInput
                                      v-model="mercadoria.valor_unitario	"  
                                      placeholder=""
                                      title="informe o valor do produto"                                      
                                    />
                                  </b-col> 

                                  
                                  <!-- DESCRIÇÃO DO PRODUTO -->
                                  <b-col cols="2" class="mb-3">
                                    <label  for="input-busca">Total</label> 
                                    <b-input-group-text>
                                                                      {{ 
                                        (parseFloat(mercadoria.valor_unitario	 || 0) * parseFloat(mercadoria.quantidade || 0)/100)
                                        .toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                        }) 
                                    }}
                                    </b-input-group-text>
                                  </b-col>



                                </b-row>

                    

                                
                               </b-col>
                            </b-row>
                          </b-col>
                          


                        </b-row>
                        
                      </b-container>

                <b-col cols="12">
                  <b-button class="mt-3 mb-3" variant="primary" block  @click="postNfCabecalho()">Gravar</b-button>
                </b-col>    

<!--
                <b-col cols="2">                                   
                  <b-button  class="mt-3 mb-3" variant="success" block  @click="postNfCabecalho()">FINANCEIRO</b-button>                  
                </b-col>   
-->


          <div class="col-12">
          <!--tbl de dados -->
          <b-table id="tbldefeitos"  small hover striped sticky-header="480px"  :items="itemnf" :fields="mercadoriasItens" >  

            <template #cell(valor_total)="data">
              {{ formatCurrency2(data.item.valor_total) }}
            </template>


            <template slot="cell(actions)" slot-scope="data"  >
              <b-button @click="editTicketItens(data.item) " v-b-modal.modal-multi-pneu title="Editar itens da nota"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
              </b-button>            
            </template>  
          </b-table>
        </div>


            </b-row>


               
              </div>




        </div>
      </div>


      <div class="col-7">     
              <b-row class="justify-content-center align-items-center">

        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

          

              <b-card                          
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE NOTAS FISCAIS"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ distinctTicketIdCount }}     
                  </h2>
                </b-card-text>
              </b-card>
            

            <b-card                  
            class="ml-2"
                style="width: 33rem;"
              
              border-variant="success"
              header="VALOR R$"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                                              {{ parseFloat(resumoNf
    .map(v => parseFloat(v.vlrtotalnfs) || 0) // Garantir que cada valor seja um número
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0) // Somar os valores
).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
}) }}

                  
                </h2>                
              </b-card-text>
      </b-card>        




      </b-card-group> 

      
                      <b-col cols="12"  class="mb-3">
                <label  for="input-busca">Pesquisa no grid</label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Pesquisar por Nº da nota fiscal"></b-form-input>              
              </b-col>        

      

      </b-row> 
        <!--  TABLE DE DADOS                               -->
        <div class="col-12">
          <!--tbl de dados -->

          <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="itemsFiltered" :fields="resumoNotasFiscais" >    

            <template #cell(vlrtotalnfs)="data">
              {{ formatCurrency2(data.item.vlrtotalnfs) }}
            </template>

            
            <template slot="cell(actions)" slot-scope="data"  >
              <b-button @click="editNotaFiscal(data.item) " v-b-modal.modal-multi-pneu title="Editar Nota fiscal"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
              </b-button>            
          </template>           
          </b-table>
        </div>
      </div>
    </div>
    
  </div>  

</template>

<script>
import { baseApiUrl, showError  } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import VueTheMask from 'vue-the-mask';
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'
import NumericInput from '../utilitarios/NumericInput';
import jsPDF from 'jspdf';
import ConsultaMaterial from '../sambaiba/CF7MaterialConsulta';
//import 'jspdf-autotable';


export default {

    name: 'ManutencaoRfiLancamento', 
    
    
    computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.resumoNf.filter((item) =>{
          return (
            item.nfs.indexOf(this.search) >-1  ||
            item.nome.indexOf(this.search) >-1  
          );
        });
        return valores
        },

        valorTotal() {
          return this.materiais.valor_mercadoria ? (this.materiais.valor_mercadoria * this.mercadoria.quantidade + 0.00) : 0.00;
        },
        formattedValue() {
          return this.formatCurrency(this.mercadoria.folha);
        },

            distinctTicketIdCount() {
      return [...new Set(this.resumoNf.map(item => item.nfs))].length;
    },

formattedTotal() {
  // Verifica se ticketitens é um array
  if (!Array.isArray(this.ticketitens)) {
    console.error('ticketitens não é um array');
    return 0;
  }

  // Calcula o total somando os valores válidos
  const total = this.ticketitens
    .map(v => {
      const valor = parseFloat(v.valor_total);
      return isNaN(valor) ? 0 : valor; // Substitui valores inválidos por 0
    })
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0.00);

  return total; // Retorna o total
}






    } ,


    data: function() {
      
      return {

        // Entrada de mercadoria -   15/08/2024
        dt_inicio: '',
        _chaveAcesso: '',
        nfs:[],     
        nf:{},
        fornecedores:[],
        materiais:[],
        itens:[],
        item:{},
        financeiros:[],
        financeiro:{},        
        vchaveacesso: '', // Inicializa o valor como uma string vazia
        formattedValue: this.formatCurrency(this.value),
        itemnf:[],
        resumoNf:[],
        isModalVisible: false,




        ///CF7 - 01/08/2024 as 21:58h
        mercadorias:[],
        mercadoria:{},
        mercadoriasitens:[],
        mercadoriaitem:{},




        formapagtos:[],
        funcionarios:[],
        funcionario:{},
        financeiros:[],
        tipopagtos:[],
        nroTicket : 0,
        ticketsintetico:[],
        ticketitens:[],
        ticketitenscard:[],
        parcelas:[],
        parcelasfolha:[],
        //////////////
        pneus:[],               
        pneu:{},
        filiais:[],
        fabricantes:[],
        vidas:[],
        borrachas:[],
        carcacas:[],
        statuss:[],
        pneussaldo:[],
        value_fornecedor:0,
        
        





        isLoading: false,
        dt_abertura: '',
            empresas:[],
            filiais:[],

            empresasf:[],
            empresaf:{},
            filialf:{},
            pneus:[],
            operador:[],            
            socorrista_carro:[],
            trocado_carro:[],
            socorristas:[],
            pneus:[],
            pneu:{},
            viacep:[],

            value_empresaf: [],



            defeitos:[],
            defeito:{},

            gruposi:[],
            subgruposi:[],
            defeitosi:[],
            
            gruposd:[],
            subgruposd:[],
            defeitosd:[],

            executante:{},
            executantes: [],  
            lider:{},
            lideres:[],





            mode: 'save',
            carregando: false,
            atualizando: false, 

            
            
            

            
            
            grupo:{},
            grupos:[],
            subgrupo:{},
            subgrupos:[],
            defeito:{},
            defeitos:[],

                        
           // gruposd:[],
            gruposd:{},
            subgrupod:{},
            subgruposd:[],
            defeitod:{},


            solicitante:{},
            solicitantes:[],


            socorrista:{},
            linhas:[],

            nropneu:[],

            pneueditdefeito:[],
            
            

            situacaojb:[],

            value_carro:'',
            value_carro_socorrista:'',
            value_carro_trocado:'',
            value_cep:'',
            value_solicitante:'',
            value_executante:'', 
            value_socorrista:'',           
            value_status:[],
            value_statusjb:[],
            value_tipo:[],
            value_lider:'',
            

            //garagem:{},             
            tipos:[] ,
            search:'',


            

            lin:{},
            
            value_garagem:[],// [] lista                         
            
            
            value_observacoes:'',
           
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            
          mercadoriasItens: [  

              { key: 'dt_emissao', label: 'Data Emissão', sortable: true, formatter: (value, key, itemnf) => {
                    return moment(itemnf.dt_emissao).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                               
              { key: 'nfs', label: 'Nota Fiscal', sortable: true },                 
              { key: 'item_id', label: 'Id', sortable: true },  
              { key: 'codigo_erp', label: 'Produto', sortable: true },   
              { key: 'descricao', label: 'Descrição', sortable: true },  
              { key: 'quantidade', label: 'Quantidade', sortable: true },                                
              { key: 'valor_unitario', label: 'R$ Unitário', sortable: true },              
              { key: 'valor_total', label: 'R$ Total', sortable: true },                   
              { key: 'dt_cadastro', label: 'Data lançamento', sortable: true, formatter: (value, key, itemnf) => {
                    return moment(itemnf.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },              
              { key: 'actions', label: 'Ações' },                
              
            ],


            //////// RESUMO NOTA FISCAIS
          resumoNotasFiscais: [                                          
                { key: 'dt_emissao', label: 'Data lançamento', sortable: true, formatter: (value, key, resumoNf) => {
                    return moment(resumoNf.dt_emissao).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },              
                { key: 'nfs', label: 'Nº NF', sortable: true },                                                
                { key: 'nome', label: 'Fornecedor', sortable: true },                                 
                { key: 'vlrtotalnfs', label: 'Valor Total', sortable: true },                                                
                { key: 'chaveacesso', label: 'Chave de acesso', sortable: true },  
                { key: 'dt_cadastro', label: 'Data lançamento', sortable: true, formatter: (value, key, resumoNf) => {
                    return moment(resumoNf.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },              
                //{ key: 'defeito_cancelado', label: 'Cancelado', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },     
                { key: 'actions', label: 'Ações' },                
            ]


        }        
    },

      watch: {
    value(newValue) {
      this.formattedValue = this.formatCurrency(newValue);
    }
  },

    filters: {
      dataFormatada(dt) {
        return dt.substring(0,4)
      }

    },

    components: {
        Multiselect,LoadingModal,VueTheMask,NumericInput,ConsultaMaterial
    },


    methods: {

      
      showModal() {
        this.isModalVisible = true;
      },


          formatCurrency(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return '';
      }

      // Convert value to a float and format it with two decimal places
      value = parseFloat(value).toFixed(2);
      
      // Split into integer and decimal parts
      let [integerPart, decimalPart] = value.split('.');

      // Add thousands separator to integer part
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      
      return `${integerPart},${decimalPart}`;
    },
    onInput(event) {
      // Extract numeric value from formatted input
      const inputValue = event.target.value.replace(/\D/g, '');
      // Convert to a numeric value with two decimal places
      const numericValue = (parseInt(inputValue, 10) / 100).toFixed(2);

      this.$emit('input', numericValue); // Emit the numeric value to the parent component
      this.formattedValue = this.formatCurrency(numericValue); // Update formatted value
    },

      async loadFornecedor() { 
            let corpo = {                             
            //"empresa_id": `${this.materiais.empresa_id}`,
            "empresa_id": `${this.user.id_empresa}`,        
            "cnpj": `${this.nf.cnpj}`,
            "filtro": 'consultafornecedor'
            };             
          const url = `${baseApiUrl}/jb/fin/clifor`
          axios.post(url,corpo)
              .then(res => { this.fornecedores = res.data })             
      }, 

async loadCarregarNotaPorChaveAcesso() { 
    let corpo = {                             
        "empresa_id": `${this.user.id_empresa}`,        
        "chaveacesso": `${this._chaveAcesso}`,
        "filtro": 'chaveacesso'
    };                       
    
    const url = `${baseApiUrl}/sambaiba/cf7/estoque/nfs`;
    try {
        const response = await axios.post(url, corpo);
        this.reset()
        this.nfS = response.data;

        // Assumindo que `response.data` é uma lista, você pode querer definir `this.nf` 
        // para o primeiro item ou o item desejado.
        if (this.nfS.length > 0) {
            this.loadDadosdaNota(this.nfS[0]);
        }
    } catch (error) {
        console.error("Erro ao carregar a nota:", error);
    }
},

loadDadosdaNota(nfs) {
    this.nf = { 
        id:nfs.id,
        nfs: nfs.nfs,              // Número da NFS
        chaveacesso: nfs.chaveacesso, // Chave de acesso
        dt_emissao: nfs.dt_emissao, // Data de emissão
        cnpj: nfs.cnpj,
        vlrproduto: nfs.vlrproduto * 100,        
        vlripi: nfs.vlripi,
        vlricms: nfs.vlricms,
        vlrfrete: nfs.vlrfrete,
        vlrdesconto: nfs.vlrdesconto,
        vlrtotalnfs: nfs.vlrtotalnfs * 100 ,
        serie: nfs.serie,
        observacao: nfs.observacao        
      };
      this.loadFornecedor()
      this.getNfItens();
      this.getNfResumoEntrada();
},

      
      


      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },



//////cf7
        formatCurrency2(amount) {
      const number = parseFloat(amount);
      if (isNaN(number)) {
        return 'R$ 0,00'; // Valor padrão se não for um número
      }
      return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },


      async loadFuncionario() { 
            let corpo = {                             
            "registro": `${this.mercadoria.re}`,
            "id_empresa": `${this.user.id_empresa}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.funcionarios = res.data })    
              this.reset()
//              this.loadNovoNroTicket()         
      },  

      async loadProdutos() { 
            let corpo = {                             
            //"empresa_id": `${this.materiais.empresa_id}`,
            "codigo_erp": `${this.mercadoria.codigo_erp}`,
            "filtro": 'CF7'
            };             
          const url = `${baseApiUrl}/sambaiba/cf7/produto`
          axios.post(url,corpo)
              .then(res => { this.materiais = res.data })             
      }, 

      
      loadNovoNroTicket() {
            const url = `${baseApiUrl}/sambaiba/cf7/nroticket`
            axios.post(url).then(res => {
              this.nroTicket = res.data.rows[0].nextval
              this.reset()
            })
      },

       ///Tipo de pagamento
        loadTipoPagto() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                           
          };          
          const url = `${baseApiUrl}/sambaiba/cf7/tipopagto`
          axios.get(url)
               .then(res => {this.tipopagtos = res.data.map(sb => {return { ... sb, value: sb.id, tipo: sb.tipo} })})
               .catch(showError)
        },

        loadParcelas() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                           
          };          
          const url = `${baseApiUrl}/sambaiba/cf7/parcelas`
          axios.get(url)
               .then(res => {this.parcelas = res.data.map(sb => {return { ... sb, value: sb.id, tipo: sb.parcela} })})
               .catch(showError)
        },

  formatCurrency(value) {
    if (!value) return '';
    value = value.toString().replace(/\D/g, ''); // Remove non-digit characters

    // Ensure at least '0'
    value = value.length ? value : '0';

    if (value.length === 1) return `0,0${value}`;
    if (value.length === 2) return `0,${value}`;
    
    const integerPart = value.slice(0, -2);
    const decimalPart = value.slice(-2);
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimalPart;
  },
  convertToDatabaseFormat(value) {
    if (!value) return '0.00';

    // Remove thousand separators (points) and replace the decimal separator (comma) with a dot
    let numericValue = value.toString().replace(/\./g, ''); // Remove all points

    // Find the position of the last comma (if any) and replace it with a dot
    const commaIndex = numericValue.lastIndexOf(',');
    if (commaIndex > -1) {
      numericValue = numericValue.slice(0, commaIndex) + '.' + numericValue.slice(commaIndex + 1);
    } else {
      numericValue += '.00'; // If no comma, add '.00'
    }

    // Ensure at least a zero
    return numericValue || '0.00';
  },

async postNfCabecalho() {
  // Define o corpo da requisição
  let corpo = {              
    "empresa_id": `${this.user.id_empresa}`,            
    "filial_id": `${this.user.id_filial_erp}`,  
    "funcionario_id": `${this.user.id_funcionario_erp}`,                                        
    "clifor_id": this.nf.clifor_id != null ? this.nf.clifor_id : `${this.fornecedores.id}`,          
    "chaveacesso": this._chaveAcesso != null ? `${this._chaveAcesso}` : null,              
    "nfs": this.nf.nfs != null ? `${this.nf.nfs}` : null,
    "dt_emissao": this.nf.dt_emissao != null ? `${this.nf.dt_emissao}`: `${this.dt_inicio}`,
    "vlrproduto": this.nf.vlrproduto != null ? `${this.nf.vlrproduto / 100}` : null,
    "vlripi": this.nf.vlripi != null ? `${this.nf.vlripi / 100}` : null,
    "vlricms": this.nf.vlricms != null ? `${this.nf.vlricms / 100}` : null,
    "vlrfrete": this.nf.vlrfrete != null ? `${this.nf.vlrfrete / 100}` : null,
    "vlrdesconto": this.nf.vlrdesconto != null ? `${this.nf.vlrdesconto / 100}` : null,
    "vlrtotalnfs": this.nf.vlrtotalnfs != null ? `${this.nf.vlrtotalnfs / 100}` : null,
    "serie": this.nf.serie != null ? `${this.nf.serie}` : null,
    "entrada_saida": this.nf.entrada_saida != null ? `${this.nf.entrada_saida}` : null,              
    "observacao": this.nf.observacao != null ? `${this.nf.observacao}` : null,    
    "filtro": 'entradanf'
  };

  const url = `${baseApiUrl}/sambaiba/cf7/estoque/nfs`;

  try {
    const response = await axios.post(url, corpo);

    // Atualiza a propriedade `nfs` com o primeiro item do array `dados` da resposta
    this.nfs = response.data.dados[0]; // Acesso ao objeto `dados` da resposta
    this.postTicketItens();

  } catch (error) {
    showError(error); // Lida com o erro de forma adequada
  }
},

async postTicketItens() {                 
            let corpo = {                           
              "empresa_id": `${this.user.id_empresa}`,            
              "filial_id": `${this.user.id_filial_erp}`,  
              "funcionario_id": `${this.user.id_funcionario_erp}`,                          
              "id":  this.mercadoria.id ? `${this.mercadoria.id}` : `${this.mercadoria.item_id}`,     ////      id referente número da nota fiscal         
              "item_id": `${this.mercadoria.item_id}`,                        ////      id referente item gravado na tabela + ml18_cf7_magazine_lancamentos_itens
              "produto_id": `${this.materiais.id  }`,
              "quantidade": `${this.mercadoria.quantidade}`,             
              "valor_unitario": `${ this.mercadoria.valor_unitario	 / 100}`,
              "rotina_id": 2,
              "clifor_id": this.nf.clifor_id != null ? this.nf.clifor_id : `${this.fornecedores.id}`,          
              "nf_id": `${this.nfs.id}`,
              "filtro": 'gravar'              
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()   
          this.getNfItens();
          this.getNfResumoEntrada();          
          this.mercadoria = {};          
          this.materiais =[]
          //this.reset()
           })
           .catch(showError)
},

async getNfItens() {  
  let corpo = {              
    "empresa_id": `${this.user.id_empresa}`,            
    "filial_id": `${this.user.id_filial_erp}`,      
    "nf_id": this.nf.id !=null ? `${this.nf.id}`: `${this.nfs.id}`,
    "filtro": 'itensnf'
  };
  const url = `${baseApiUrl}/sambaiba/cf7/estoque/nfs`;
  try {
    const response = await axios.post(url, corpo);    
    this.itemnf = response.data;
  } catch (error) {
    showError(error);
  }
},

async getNfResumoEntrada() {  
  let corpo = {              
    "empresa_id": `${this.user.id_empresa}`,                
    "filtro": 'resumoentradanf'
  };
  const url = `${baseApiUrl}/sambaiba/cf7/estoque/nfs`;
  try {
    const response = await axios.post(url, corpo);    
    this.resumoNf = response.data;
  } catch (error) {
    showError(error);
  }
},


      async postFinanceiroParcelas() {                 
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "ticket_id": this.nroTicket ? this.nroTicket : this.mercadoria.ticket_id,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              //"dt_emissao": `${this.funcionarios.id_funcao}`,
              //"dt_vencimento": `${this.funcionarios.id_funcao}`,              
              "parcela_id": `${this.mercadoria.parcela_id}`,
              "tipopagto_id": `${this.mercadoria.tipopagto_id}`,              
              "total":  `${this.formattedTotal}`,                                 
              "filtro": 'gravarparcelas'
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/financeiro`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTicketSintetico()
          this.loadParcelasFolha()
          //this.postTicketItens()          
          //this.reset()
           })
           .catch(showError)
      },




  loadTicketSintetico() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,        
        "filtro": "lancamentodia"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketsintetico = res.data;  // Atualiza os dados do pneu                
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketsintetico = {};                
            }
        })
        .catch(showError);
  },

  loadTicketItens() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,        
        "ticket_id": this.nroTicket ? `${this.nroTicket}` :`${this.mercadoria.ticket_id}`,
        "filtro": "lancamentodia"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketitens = res.data;  // Atualiza os dados do pneu
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketitens = {};                
            }
        })
        .catch(showError);
  },

    loadTicketItensCard() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,                
        "filtro": "lancamentodiacard"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketitenscard = res.data;  // Atualiza os dados do pneu
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketitenscard = {};                
            }
        })
        .catch(showError);
  },


async gerarPDFLesser() {
  try {
    const doc = new jsPDF();
    const startX = 14;
    const startY = 10;
    const fontSize = 8; // Defina o tamanho da fonte desejado

    doc.setFontSize(fontSize); // Define o tamanho da fonte para todos os textos seguintes

    // URL da imagem
    const imageUrl = 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/logotipo/LOGO_SAMBAIBA.png';

    // Função para carregar a imagem a partir da URL
    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.crossOrigin = 'Anonymous'; // Para evitar problemas de CORS
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    };

    const image = await loadImage(imageUrl);

    // Adicionar tabela com imagem, texto e campos antes do texto 'CF7'
    const tableData = [
      [
        { content: '', image: image, width: 16, height: 16 }, // Primeira coluna: Imagem
        { content: 'CF7 STORE' }, // Segunda coluna: Texto
        {
          content: (this.nroTicket ? 'Nº ticket \n' + this.nroTicket : 'Nº ticket \n' + this.mercadoria.ticket_id) + '\n' +
                   'Data Emissão \n' + moment(this.mercadoria.dt_cadastro).format('DD/MM/YYYY HH:mm') // Formatar a data corretamente
        } // Terceira coluna: Texto
      ]
    ];

    // Adiciona a primeira tabela
    doc.autoTable({
      startY: startY,
      body: tableData,
      columnStyles: {
        0: { cellWidth: 27, halign: 'center', valign: 'middle' }, // Tamanho e alinhamento da coluna 0 (Imagem)
        1: { cellWidth: 115, halign: 'center', valign: 'middle' }, // Tamanho e alinhamento da coluna 1 (Texto)
        2: { cellWidth: 50, halign: 'center', valign: 'middle' }   // Tamanho e alinhamento da coluna 2 (Texto)
      },
      styles: {
        fillColor: [255, 255, 255], // Fundo branco
        textColor: [0, 0, 0], // Texto preto
        lineColor: [0, 0, 0], // Bordas pretas
        halign: 'center', // Centralizar texto horizontalmente
        valign: 'middle' // Centralizar texto verticalmente
      },
      tableLineColor: [0, 0, 0], // Bordas pretas
      tableLineWidth: 0.1, // Largura das bordas
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.raw.image) {
          doc.addImage(data.cell.raw.image.src, 'PNG', data.cell.x + 2, data.cell.y + 2, data.cell.raw.width, data.cell.raw.height);
        }

        // Desenhar linha vertical entre a segunda e terceira colunas
        if (data.column.index === 1) {
          const cell = data.cell;
          doc.setDrawColor(0, 0, 0); // Cor preta para a linha
          doc.setLineWidth(0.1); // Largura da linha
          doc.line(cell.x + cell.width, cell.y, cell.x + cell.width, cell.y + cell.height);
        }
      }
    });

    // Ajuste o valor de startY para a próxima tabela
    const newTableStartY = doc.autoTable.previous.finalY + 10; // 10 é o espaçamento adicional entre as tabelas

    // Adicionar nova tabela com 1 linha e 3 colunas
    const newTableData = [
      ['Registro.:' + this.funcionarios['re'] + '\n' + 'Função.: '+ this.funcionarios['funcao'] + '\n' +  'Nome.: ' + this.funcionarios['nome'], '','']
    ];

    // Posição informações do funcionário
    doc.autoTable({
      startY: newTableStartY - 8,
      body: newTableData,
      columnStyles: {
        0: { cellWidth: 180, halign: 'left' }, // Alinhar coluna 0 (Texto) ao centro
        1: { cellWidth: 1, halign: 'left' }, // Alinhar coluna 1 (Texto) ao centro
        2: { cellWidth: 1, halign: 'left' }  // Alinhar coluna 2 (Texto) ao centro
      },
      styles: {
        fillColor: [255, 255, 255], // Fundo branco
        textColor: [0, 0, 0], // Texto preto
        lineColor: [0, 0, 0], // Bordas pretas
        halign: 'center', // Centralizar texto horizontalmente
        valign: 'middle' // Centralizar texto verticalmente
      },
      tableLineColor: [0, 0, 0], // Bordas pretas
      tableLineWidth: 0.1 // Largura das bordas
    });

    // Adicionar tabela com parcelasfolha
    const parcelasfolhaData = this.parcelasfolha.map(parcela => [
      parcela.parcela || '', // Exemplo de dado
      parseFloat(parcela.valor_parcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || '', // Exemplo de dado
      moment(parcela.dt_vencimento).format('DD/MM/YYYY') || '' // Exemplo de dado
    ]);

    const parcelasfolhaHeaders = ['Parcela', 'Valor', 'Data'];

    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 50, // TABELA DE PARCELAS
      head: [parcelasfolhaHeaders],
      body: parcelasfolhaData,
      columnStyles: {
        0: { cellWidth: 40, halign: 'center' },
        1: { cellWidth: 40, halign: 'right' },
        2: { cellWidth: 40, halign: 'center' }
      },
      styles: { fontSize: 8, cellPadding: 2, valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.1 }, // Adicionar bordas pretas
      headStyles: { fontStyle: 'bold' },
      didDrawCell: function (data) {
        const cell = data.cell;
        const doc = data.doc;
        doc.rect(cell.x, cell.y, cell.width, cell.height, 'S'); // Desenhar as bordas
      }
    });

    // Cabeçalhos da tabela
    const headers = ['Item', 'Código', 'Descrição', 'Quantidade', 'Valor unitário', 'Total'];

    // Preparar os dados para o PDF com formatação de moeda
    const dadosParaPDF = this.ticketitens.map((item, index) => {
      const valorUnitario = parseFloat(item.valor_unitario) || 0;
      const quantidade = parseFloat(item.quantidade) || 0;
      const total = valorUnitario * quantidade;
      const totalgeral = valorUnitario * quantidade;

      return [
        index + 1, // Adiciona o índice (começando de 1 para ser mais intuitivo)
        item.codigo_erp || '', // Coluna 2: Código
        item.descricao || '', // Coluna 3: Descrição
        quantidade, // Coluna 4: Quantidade
        valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // Coluna 5: Valor unitário formatado
        total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // Coluna 6: Total formatado
        totalgeral
      ];
    });

    // Calcular a soma total geral
    const somaTotal = dadosParaPDF.reduce((acumulador, linha) => {
      // Utiliza linha[5] que contém o total como número não formatado
      const valorTotal = parseFloat(linha[6]) || 0;
      return acumulador + valorTotal;
    }, 0);

    // Adicionar a soma total geral no final
    dadosParaPDF.push([
      'Total Geral', // Texto para a coluna de índice
      '', // Coluna 2: Vazio para o código
      '', // Coluna 3: Vazio para a descrição
      '', // Coluna 4: Vazio para a quantidade
      '', // Coluna 5: Vazio para o valor unitário
      somaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) // Coluna 6: Total Geral formatado
    ]);

    // Número de linhas por página
    const rowsPerPage = 12;

    for (let i = 0; i < dadosParaPDF.length; i += rowsPerPage) {
      const currentData = dadosParaPDF.slice(i, i + rowsPerPage);

      if (i > 0) {
        doc.addPage();
      }

      doc.autoTable({
        startY: 50,
        head: [headers],
        body: currentData,
        theme: 'plain',
        columnStyles: {
          0: { cellWidth: 20, halign: 'center' }, // Alinhar coluna 0 (Item) ao centro
          1: { cellWidth: 20, halign: 'center' }, // Alinhar coluna 1 (Código) ao centro
          2: { cellWidth: 62, halign: 'left' }, // Alinhar coluna 2 (Descrição) à esquerda
          3: { cellWidth: 20, halign: 'right' }, // Alinhar coluna 3 (Quantidade) à direita
          4: { cellWidth: 30, halign: 'right' }, // Alinhar coluna 4 (Valor unitário) à direita
          5: { cellWidth: 30, halign: 'right' } // Alinhar coluna 5 (Total) à direita
        },
        styles: { fontSize: 8, cellPadding: 2, valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.1 }, // Adicionar bordas pretas
        headStyles: { fontStyle: 'bold' },
        didDrawCell: function (data) {
          const cell = data.cell;
          const doc = data.doc;
          doc.rect(cell.x, cell.y, cell.width, cell.height, 'S'); // Desenhar as bordas
        }
      });
    }

    const pageCount = doc.internal.getNumberOfPages();
    const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const footerX = 10;
      const footerY = doc.internal.pageSize.height - 10;
      const currentDate = moment().format('DD/MM/YYYY - HH:mm');
      const pageNumber = 'Página ' + i + ' de ' + pageCount;
      const footerText = 'Data: ' + currentDate + ' | ' + pageNumber;

      doc.setFontSize(footerFontSize); // Define o tamanho da fonte
      doc.text(footerText, footerX, footerY);

      // Verifica se estamos na última página
      if (i === pageCount) {
        const assinaturaY = footerY - 10; // Ajuste conforme necessário
        doc.text("____________________________________________________________________", footerX, assinaturaY - 5);
        doc.text("Assinatura: " + this.funcionarios['nome'] + '-' + this.funcionarios['funcao'], footerX, assinaturaY);
      }
    }

    doc.save('Ticket_' + this.mercadoria.ticket_id + '_funcionario_' + this.funcionarios['re'] + '.pdf');
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
  }
}

,

      loadParcelasFolha() {         
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,        
        "ticket_id": this.nroTicket ? `${this.nroTicket}` :`${this.mercadoria.ticket_id}`,
                          
          };
          const url = `${baseApiUrl}/sambaiba/cf7/financeiro/folha`
          axios.post(url,corpo).then(res => { 
            this.parcelasfolha = res.data  
            }            
          )
          .catch(showError)         
      },






      limparFiltro(){
        this.search= ""
      },

        
      loadEmpresa() {
                    let corpo = {    
                        "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
                    };
        
                  const url = `${baseApiUrl}/ctr/empresa`
                  axios.post(url,corpo)
                  .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
                  .catch(showError)
      },
      
      loadFilial() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo)
          .then(res => {this.filiais = res.data.map(emp => {return { ... emp, value: emp.id_filial_erp, filial: emp.filial, empresa_id: emp.empresa_id } })})
          .catch(showError)
          
      },

              ///CHASSI FABRICANTE
      loadFabricante() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/fabricante`
          axios.post(url,corpo)
               .then(res => {this.fabricantes = res.data.map(gru => {return { ... gru, value: gru.id, fabricante: gru.fabricante} })})
               .catch(showError)          
        }, 

       
        loadVida() {             
          const url = `${baseApiUrl}/pneu/vida`
          axios.get(url)
               .then(res => {this.vidas = res.data.map(sb => {return { ... sb, value: sb.id, vida: sb.vida} })})
               .catch(showError)
        },





              
      loadBorracha() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/borracha`
          axios.post(url,corpo)
               .then(res => {this.borrachas = res.data.map(gru => {return { ... gru, value: gru.id, borracha: gru.borracha} })})
               .catch(showError)          
        }, 


              
      loadCarcaca() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/desenho`
          axios.post(url,corpo)
               .then(res => {this.carcacas = res.data.map(gru => {return { ... gru, value: gru.id, desenho: gru.desenho} })})
               .catch(showError)          
        }, 


              
      loadStattus() {        
          const url = `${baseApiUrl}/pneu/status`
          axios.get(url)
               .then(res => {this.statuss = res.data.map(gru => {return { ... gru, value: gru.id, status: gru.status} })})
               .catch(showError)          
        }, 

              ///////////////////////////////// 31/12/2022 as 20:17h
      editTicketResumo(mercadoria){
            this.mercadoria = { ...mercadoria }          
            this.getNfItens();
          this.getNfResumoEntrada();
            
            
            //this.loadTicketItens()
            //this.loadFuncionario()
            //this.loadProdutos()            
      },

      
      ///////////////////////////////// 31/12/2022 as 20:17h
      editTicketItens(mercadoria){
            this.mercadoria = {
              valor_unitario: mercadoria.valor_unitario * 100 ,
              quantidade: mercadoria.quantidade,
              codigo_erp: mercadoria.codigo_erp,
              item_id: mercadoria.item_id
              }    
             this.getNfItens();
          this.getNfResumoEntrada();
            this.loadProdutos()    
       
      },

            ///////////////////////////////// 31/12/2022 as 20:17h
editNotaFiscal(resumoNf) {
    this._chaveAcesso = resumoNf.chaveacesso;
    this.loadCarregarNotaPorChaveAcesso();            
},

      /*
loadDadosdaNota(nfs) {
    this.nf = { 
        id:nfs.id,
        nfs: nfs.nfs,              // Número da NFS
        chaveacesso: nfs.chaveacesso, // Chave de acesso
        dt_emissao: nfs.dt_emissao, // Data de emissão
        cnpj: nfs.cnpj,
        vlrproduto: nfs.vlrproduto * 100,        
        vlripi: nfs.vlripi,
        vlricms: nfs.vlricms,
        vlrfrete: nfs.vlrfrete,
        vlrdesconto: nfs.vlrdesconto,
        vlrtotalnfs: nfs.vlrtotalnfs * 100 ,
        serie: nfs.serie,
        observacao: nfs.observacao        
      };
      this.loadFornecedor()
      this.getNfItens();
      this.getNfResumoEntrada();
},

      */

      
      loadPneuSaldo() {         
          let corpo = {    
               "empresa_id": `${[this.pneu.empresa_id]}`,                                           
               "filial_id": `${[this.pneu.filial_id]}`,
               "origem" : "websaldo"           
          };
          const url = `${baseApiUrl}/pneu/pneu`
          axios.post(url,corpo).then(res => { 
            this.pneussaldo = res.data  
            }            
          )
          .catch(showError)         
      },
      
     
      reset() {
        //this.resumoNf= []
        this.mercadoria = []
        this.itemnf = []
        this.nfs = []
        this.nf = {}
      },

      limparCorpo(){
        this.defeito =[]        
        this.executante=[]
       this.lider=[]        
       this.value_executante=''
        this.value_lider=''
        ///this.nropneu=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
      },

      novo(){
        this.pneu = {}
        this.defeito = {}                
        this.pneueditdefeito = {}     
      },

            

       
    },
    
    mounted() {   
      this.loadEmpresa() 
      this.loadFilial()
      this.getNfResumoEntrada()


    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#placa{
    font-size: 0.7em;  
}

#lblChaveAcesso{
  font-size: 0.9em; 
  color: blue;    
}

#cardvalorticket{
    font-size: 1.3em;      
}


#modal-multi-pneu___BV_modal_content_{
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;  
}


#defeito-selecao{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;  
}

#id-sos{  
  background: rgb(199, 222, 218);
  border: 1px solid red ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#id-encerramento{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#pneu-nro{
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
  
}



#garagem{  
  font-size: 12px;
  text-align: center;
  
}



/* Define a altura e a largura da imagem */
.img-custom {
  width: 150px; /* Ajuste conforme necessário */
  height: 150px; /* Ajuste conforme necessário */
  object-fit: cover; /* Garante que a imagem cubra a área sem distorcer */
}


.alert-container {
  position: fixed; /* Fixa o elemento na tela */
  top: 50%; /* Move o elemento para o meio verticalmente */
  left: 50%; /* Move o elemento para o meio horizontalmente */
  transform: translate(-50%, -50%); /* Ajusta a posição para o centro do elemento */
  z-index: 1000; /* Garante que o alerta ficará sobre outros conteúdos */
}

#divisao {
      border: 0;
      height: 4px;
      background: #1405ee; /* Cor da linha */
      margin: 20px 0; /* Espaço acima e abaixo da linha */
    }


</style>